import cn from "classnames";

import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { connect } from "react-redux";

import { Route, Router, Switch, Link, Redirect,useLocation } from "react-router-dom";
import { createBrowserHistory } from "history";
import Home from "./component/home";
import Summary from "./component/summary";
import Visualization from "./component/visualization_new";
import VisualizationR from "./component/visualization_new_R/index";
import Query from "./component/query";
import QueryR from "./component/query-R";
import Header from "./component/header/header.component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import Cleaning from "./component/cleaning";
import CleaningR from "./component/cleaning-R";
import Sandbox from "./component/sandbox";
import SandboxR from "./component/sandbox-R"
import FeatureEngineering from "./component/featureEngineering";
import FeatureEngineeringR from "./component/featureEngineering-R";
import FeatureSelectionR from "./component/featureSelection-R";
import AnalysisR from "./component/analysis-R";
import Preprocessing from "./component/preprocessing";
import PreprocessingR from "./component/preprocessing-R";
import FeatureSelection from "./component/featureSelection";
import Analysis from "./component/analysis";
import Download from "./component/download";
import Guide from "./component/guide";
import EnterOtp from "./component/enter-otp/enter-otp"
// testing dummy
import { login } from "./actions/auth";
import { fetchByJSON, useCachedData, datasetSourceLabel } from "./util/util";
import { config } from './config/client'

//Login imports
import Login from "./component/login/login.component";
import Register from "./component/register/register.component";
import Profile from "./component/profile/profile.component";
import Dashboard from "./component/profile/dashboard.component";
import Materials from "./component/materials"
import ForgotPassword from "./component/forgot_password/forgot_password.component";
import ResetPasswordConfirm from "./component/reset_password/reset_password.component";
import PendingRequests from "./component/pending-requests/pending-requests.component";
import Quiz from "./component/quiz/quiz.component";
import QuizList from "./component/quiz/quiz.list.component";
import QuizEdit from "./component/quiz/quiz.edit.component";
import Question from "./component/question/question.component";
import AdminDashboard from "./component/admin/AdminDashboard";

import { logout } from "./actions/auth";
import { clearMessage } from "./actions/message";

import vivek_profile from "./assets/images/vivek_profile.jpg";
import avatar from "./assets/images/avatar.png";
import arrow from "./assets/images/arrow.svg";

import { history } from "./store";
import "./route.css";
import logo from './assets/images/new_RIT_logo1_RGB_0.png'

import Idle from './Idle'
import Classroom from './component/classroom/classroom.jsx'; // added import
//add all solid icon-fonts
library.add(fas);
library.add(far);

const MenuR = {
  // User: [{ text: "Profile", icon: "home", to: "/profile" }],
  User: [
    // { text: "Admin", icon: "home", to: "/admin" }
  ],
  Main: [
    { text: "Dashboard", icon: "user", to: "/" },
    { text: "Materials", icon: "graduation-cap", to: "/materials"},
    { text: "Data", icon: "home", to: "/data" },
    { text: "Guide", icon: "book-reader", to: "/guide" },
    { text: "Summary", icon: "chart-area", to: "/summary" },
    { text: 'R Sandbox', icon: 'chart-area', to: '/sandbox-r' },
    { text: "Query R", icon: "search", to: "/query-r" },
    { text: "Data Cleaning R", icon: "broom", to: "/clean-r" },
    { text: "Data Preprocessing R", icon: "filter", to: "/preprocessing-r" },
    { text: "Data Visualization R", icon: "chart-pie", to: "/visualization-r" },
    { text: "Feature Engineering R", icon: "cog", to: "/featureEngineering-r" },
    { text: "Feature Selection R", icon: "list", to: "/featureSelection-r" },
    { text: "Analysis R", icon: "microscope", to: "/analysis-r" },
    { text: "Download Dataset", icon: "cloud-download-alt", to: "/download" },
    { text: "Quiz", icon: "lightbulb", to: "/quiz/list" },
  ],
};

const MenuPython = {
    // User: [{ text: "Profile", icon: "home", to: "/profile" }],
    User: [
      // { text: "Admin", icon: "home", to: "/admin" }
    ],
    Main: [
      { text: "Dashboard", icon: "user", to: "/" },
      { text: "Materials", icon: "graduation-cap", to: "/materials"},
      { text: "Data", icon: "home", to: "/data" },
      { text: "Guide", icon: "book-reader", to: "/guide" },
      { text: "Summary", icon: "chart-area", to: "/summary" },
      { text: 'Sandbox', icon: 'chart-area', to: '/sandbox' },
      { text: "Query", icon: "search", to: "/query" },
      { text: "Data Cleaning", icon: "broom", to: "/clean" },
      { text: "Data Preprocessing", icon: "filter", to: "/preprocessing" },
      { text: "Data Visualization", icon: "chart-pie", to: "/visualization" },
      { text: "Feature Engineering", icon: "cog", to: "/featureEngineering" },
      { text: "Feature Selection", icon: "list", to: "/featureSelection" },
      { text: "Analysis", icon: "microscope", to: "/analysis" },
      { text: "Download Dataset", icon: "cloud-download-alt", to: "/download"},
      { text: "Quiz", icon: "lightbulb", to: "/quiz/list" },
    ],
  };


const Menu = {
  // User: [{ text: "Profile", icon: "home", to: "/profile" }],
  User: [
    // { text: "Admin", icon: "home", to: "/admin" }
  ],
  Main: [
    { text: "Dashboard", icon: "user", to: "/" },
    { text: "Materials", icon: "graduation-cap", to: "/materials"},
    { text: "Data", icon: "home", to: "/data" },
    { text: "Guide", icon: "book-reader", to: "/guide" },
    { text: "Summary", icon: "chart-area", to: "/summary" },
    { text: 'Sandbox', icon: 'chart-area', to: '/sandbox' },
    { text: "Query", icon: "search", to: "/query" },
    { text: "Data Cleaning", icon: "broom", to: "/clean" },
    { text: "Data Preprocessing", icon: "filter", to: "/preprocessing" },
    { text: "Data Visualization", icon: "chart-pie", to: "/visualization" },
    { text: "Feature Engineering", icon: "cog", to: "/featureEngineering" },
    { text: "Feature Selection", icon: "list", to: "/featureSelection" },
    { text: "Analysis", icon: "microscope", to: "/analysis" },
    { text: "Download", icon: "cloud-download-alt", to: "", isDownload:true },
    { text: "Download Dataset", icon: "cloud-download-alt", to: "", isDownload:true },
    { text: "Quiz", icon: "lightbulb", to: "/quiz/list" },
  ],
};

const DATA_MINING_SVG = () => (
  <>
  {/* <img src={logo}/> */}
  </>
  // <svg
  //   fill="#ffffff"
  //   xmlns="http://www.w3.org/2000/svg"
  //   viewBox="0 0 50 50"
  //   width="25px"
  //   height="25px"
  // >
  //   <path d="M 7 2 C 4.199219 2 2 4.199219 2 7 L 2 34 C 2 36.800781 4.199219 39 7 39 L 34 39 C 36.800781 39 39 36.800781 39 34 L 39 7 C 39 4.199219 36.800781 2 34 2 Z M 7 4 L 34 4 C 35.699219 4 37 5.300781 37 7 L 37 34 C 37 35.699219 35.699219 37 34 37 L 7 37 C 5.300781 37 4 35.699219 4 34 L 4 7 C 4 5.300781 5.300781 4 7 4 Z M 41 11 L 41 13 L 43 13 C 44.699219 13 46 14.300781 46 16 L 46 43 C 46 44.699219 44.699219 46 43 46 L 16 46 C 14.300781 46 13 44.699219 13 43 L 13 41 L 11 41 L 11 43 C 11 45.800781 13.199219 48 16 48 L 43 48 C 45.800781 48 48 45.800781 48 43 L 48 16 C 48 13.199219 45.800781 11 43 11 Z" />
  // </svg>
);

const LogoutSVG = () => (
  <svg
    fill="#ffffff"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <path d="M16 9v-4l8 7-8 7v-4h-8v-6h8zm-16-7v20h14v-2h-12v-16h12v-2h-14z" />
  </svg>
);
const ArrowSVG = ({ directionDown = true }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={cn(
      directionDown ? "down" : "up",
      "cursor-pointer",
      "rounded-full",
      "w-4",
      "h-4",
      "ml-2",
      "m_transition"
    )}
  >
    <polyline points="18 15 12 9 6 15"></polyline>
  </svg>
);

const Routes = (props) => {
  const { userEnv } = process.env;
  const dispatch = useDispatch();
  const { user: currentUser } = useSelector((state) => state.auth);

  let dataset = useSelector((state) => state.dataset);
  const selectedLanguage = useSelector((state) => state.language.selectedLanguage);
  let Menu = selectedLanguage === 'R' ? MenuR : MenuPython;
  let [menuData, setMenuData] = useState(Menu);
  let [toggle, setToggle] = useState(false);
  useCachedData()
  let location = useLocation();
  

  if (currentUser && currentUser.role === "admin") {
    // Add Admin menu item as the second slot (index 1) if not already present.
    if (!Menu["Main"].some((el) => el.text === "Admin")) {
        Menu["Main"].splice(1, 0, { text: "Admin", icon: "shield-alt", to: "/admin" });
    }
    const found = Menu["Main"].some((el) => el.text === "Requests");
    if (!found) {
      Menu["Main"].push({ text: "Requests", icon: "home", to: "/requests" });
    }
  }
  if (currentUser && currentUser.role === "Instructor") {
    const found = Menu["Main"].some((el) => el.text === "Classroom");
    if (!found) {
      Menu["Main"].splice(1, 0, { text: "Classroom", icon: "chalkboard", to: "/classroom" });
    }
    }
  // if(userEnv === 'default'){
  //     useEffect(() => {
  //         dispatch(login("dummy_user", "dummy@123"))
  //         .then(() => {
  //           props.history.push("/home");
  //           window.location.reload();
  //         })
  //         .catch(() => {
  //           console.log("loginfailed")
  //         });
  //     }, [])
  // }
  const logOut = (e) => {
    e.preventDefault();
    dispatch(logout())
      .then((res) => {
        createBrowserHistory().push("/login");
        window.location.reload();
      })
      .catch((err) => {
        createBrowserHistory().push("/login");
        window.location.reload();
        console.log(err);
      });
  };

  useEffect(() => {
    setMenuData((data) => {
      const dataItemIndex = data.Main.findIndex(item => item.text === "Data");
      const label = datasetSourceLabel(dataset.isDefault);
      data.Main[dataItemIndex].extraText = dataset.filename && label ? `${dataset.filename} ${label}` : dataset.filename;
      return { ...data };
    });
  }, [dataset.filename, dataset.isDefault]);
  useEffect(() => {
    history.listen((location) => {
      dispatch(clearMessage()); // clear message when changing location
    });
  }, [dispatch]);

  return (
    <Router history={history}>
      <div>
        {!currentUser && (
          <section className="navigation">
            <div className="nav-container">
              <div className="logo flex">
                <nav>
                  <div>
                    <Link to={"/"}>
                      <img src={logo} width="100" height="100"></img>
                    </Link>
                  </div>
                </nav>
                {/* <Link to={"/"}>
                  <div className="flex justify-center items-center">
                    <DATA_MINING_SVG />
                    <div className="pl-2">Data Science Learning Platform</div>
                  </div>
                </Link> */}
                <div className="pl-2">Data Science Learning Platform</div>
              </div>
              <nav>
                <div className="nav-mobile">
                  <a id="nav-toggle" href="">
                    <span></span>
                  </a>
                </div>

                <ul className="nav-list">
                  <li>
                    <Link to={"/login"} title="login with an existed account">Login</Link>
                  </li>
                  <li>
                    <Link to={"/register"} title="register a new account">Register</Link>
                  </li>
                  <li>
                    <Link to={{pathname:"https://www.youtube.com/channel/UCFrjZE5lzonruR_3kmN4_zQ/videos"}} target="_blank" title="Check YouTube tutorial channel">Tutorial</Link>
                  </li>
                </ul>
              </nav>
            </div>
          </section>
        )}
        <div>
          <div className="min-h-screen flex flex-col flex-auto flex-shrink-0 antialiased">
            {/* {     !currentUser &&
            <div className="login-page">
                <div className="overlay"></div>
                <div className="login-container">
                    <img className="login-img" src="src\assets\images\image4.jpg" alt="image1" />
                </div>

            </div>
            
            } */}
            {currentUser && (
              <div className={`fixed flex flex-col left-0 w-2/12 h-full border-r ${selectedLanguage === 'R' ? 'rit-theme' : ''}`}>
                <div className="flex items-center justify-center h-20 heading">
                <DATA_MINING_SVG/>
                <Idle></Idle>
                  <div className="m-2 text-xl router-left-title">Data Science Learning Platform</div>
                </div>

                <div className="overflow-y-auto overflow-x-hidden flex-grow sidebar">
                  <div className="user flex">
                    <div className="user-details w-full">
                      <div className="profilepic" size="40">
                        <img
                          className="img"
                          src={"data:image/png;base64," + currentUser.avatar}
                        />
                      </div>
                      <div className="Id flex items-center justify-between flex-row w-full">
                        <div
                          onClick={() => setToggle(!toggle)}
                          className="flex justify-center items-center flex-row overflow-hidden"
                          style={{ maxWidth: "70%" }}
                        >
                          <div className="userId">{currentUser.username}</div>
                          <div
                            className="flex items-center"
                            style={{ marginTop: "5px", height: "28px" }}
                          >
                            <ArrowSVG directionDown={!toggle} />
                          </div>
                        </div>
                        <div
                          onClick={(e) => {
                            logOut(e);
                          }}
                        >
                          <LogoutSVG />
                        </div>
                      </div>
                        {/* {toggle && 
                          <Link to="/profile">
                              View Profile
                          </Link>
                        } */}
                      {/* <div className="arrow-span flex items-center pl-16">
                                            <div className="arrow-div">
                                                <img src={arrow} />
                                            </div>
                                        </div> */}
                    </div>

                    <div
                      className={
                        toggle ? "profile-dropdown" : "hidden invisible"
                      }
                    >
                      <ul className="dropdown-items">
                        <li>
                          <a href="#" className="w-full">
                            Signed in as {currentUser.username}
                          </a>
                          {/* <div className=''></div> */}
                        </li>
                        <hr className="hor-row" />
                        <li>
                          <a href="/profile" className="w-full">
                            Your Profile
                          </a>
                        </li>
                        {/* <li>
                          <a href="" className="w-full">
                            Settings
                          </a>
                        </li>
                        <hr className="hor-row" />
                        <li>
                          <a href="/login" className="w-full" onClick={logOut}>
                            Sign out
                          </a>
                        </li> */}
                      </ul>
                    </div>
                  </div>

                  <hr className="hor-row" />
                  <ul className="flex flex-col py-4 sidebar-hover">
                    {Object.keys(menuData).map((menu) => (
                      <React.Fragment key={menu}>
                        {menu != "User" && toggle ? (
                          <div
                            className="ml-3"
                            style={{width: "80%" }}
                          >

                          </div>
                        ) : null}

                        {Menu[menu].map((item) => (
                          <div
                            className={`
                            ${location.pathname === item.to?'menu-list-active':''}
                            ${
                              menu == "Main" || toggle
                                ? "menu-list-user-show"
                                : "menu-list-user-hidden"
                            } menu-list menu-list-transition`}
                            key={item.text}
                          >
                            {item.isDownload?<a title="Download current dataset" className="relative flex flex-row items-center h-11 focus:outline-none border-l-4 border-transparent hover-border pr-6"
                              href={`${config.endpoint}currentDataDownload?token=${currentUser.id}@${dataset.filename}`}
                                target="iframe"
                            ><span className="inline-flex justify-center items-center ml-6">
                                <FontAwesomeIcon icon={item.icon} />
                            </span>
                          <span className="ml-2 text-sm tracking-wide truncate">
                            {item.text}
                          </span>
                          <span
                            style={{
                              textOverflow: `ellipsis`,
                              overflow: `hidden`,
                              whiteSpace: `nowrap`,
                            }}
                            className={`${
                              item.extraText ? "" : "hidden"
                            } px-2 py-0.5 ml-auto text-xs font-medium tracking-wide text-indigo-500 bg-indigo-50 rounded-full`}
                          >
                            {item.extraText}
                          </span></a>:
                            <Link
                                to={item.to}
                                onClick={(e) => {
                                    // treat "/" and "/home" as the dashboard
                                    const isDashboardItem = item.text === "Dashboard" || item.to === "/" || item.to === "/home";
                                    const isCurrentlyOnDashboard = location.pathname === "/" || location.pathname === "/home";
                                    const isNavigatingToDashboard = item.to === "/" || item.to === "/home";

                                    if (isDashboardItem && isCurrentlyOnDashboard && isNavigatingToDashboard) {
                                    e.preventDefault();          // stop react-router from handling it
                                    window.location.reload();    // hard refresh the page
                                    }
                                }}
                                className="relative flex flex-row items-center h-11 focus:outline-none border-l-4 border-transparent hover-border pr-6"
                                >
                                <span className="inline-flex justify-center items-center ml-4">
                                    <FontAwesomeIcon icon={item.icon} />
                                </span>
                                <span className="ml-2 text-sm tracking-wide truncate">
                                    {item.text}
                                </span>
                                <span
                                    title={item.extraText || undefined}
                                    style={{ textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" }}
                                    className={`${item.extraText ? "" : "hidden"} px-2 py-0.5 ml-auto text-xs font-medium tracking-wide text-indigo-500 bg-indigo-50 rounded-full`}
                                >
                                    {item.extraText}
                                </span>
                                </Link>
                            }
                          </div>
                        ))}
                      </React.Fragment>
                    ))}
                  </ul>
                </div>
              </div>
            )}

            <div
              className={
                currentUser
                  ? "w-10/12 absolute right-0 h-screen content overflow-auto bg-gray-100"
                  : "flex h-screen flex-col justify-center"
              }
            >
              {/* <div className='block w-full h-16'>&nbsp;</div> */}
              <Switch>
                <Route path="/admin" component={AdminDashboard} />
                <Route path="/login" component={Login} />
                <Route path="/guide" component={Guide} />
                <Route path="/register" component={Register} />
                <Route path="/profile" component={Profile} />
                <Route path="/materials" component={Materials} />
                <Route exact path={["/home", "/"]} component={Dashboard} />
                <Route path="/data" component={Home} />
                <Route path="/summary" component={Summary} />
                <Route path="/visualization" component={Visualization} />
                <Route path="/visualization-r" component={VisualizationR} />
                <Route path='/sandbox' component={Sandbox} />
                <Route path='/sandbox-r' component={SandboxR} />
                <Route path="/query" component={Query} />
                <Route path="/query-r" component={QueryR} />
                <Route path="/clean" component={Cleaning} />
                <Route path="/clean-r" component={CleaningR} />
                <Route path="/download" render={(props) => (<Download user={currentUser} language={selectedLanguage} filename={dataset.filename} isDefault={dataset.isDefault}/>)}/>
                <Route
                  path="/featureEngineering"
                  component={FeatureEngineering}
                />
                <Route
                  path="/featureEngineering-r"
                  component={FeatureEngineeringR}
                />
                <Route path="/preprocessing" component={Preprocessing} />
                <Route path="/preprocessing-r" component={PreprocessingR} />
                <Route path="/featureSelection" component={FeatureSelection} />
                <Route path="/featureSelection-r" component={FeatureSelectionR} />
                <Route path="/analysis" component={Analysis} />
                <Route
                  path="/analysis-r"
                  component={AnalysisR}
                />
                <Route exact path="/forgot" component={ForgotPassword} />
                <Route path="/enterOtp" component={EnterOtp}/>
                <Route
                  exact
                  path="/reset"
                  component={ResetPasswordConfirm}
                />
                <Route path="/requests" component={PendingRequests} />
                <Route path="/quiz/take/:id" component={Quiz} />
                <Route path="/quiz/list" component={QuizList} />
                <Route path="/quiz/edit/:id" component={QuizEdit} />
                <Route path="/question" component={Question} />
                <Route path="/classroom" component={Classroom} /> {/* added route */}
              </Switch>
            </div>
            <iframe name="iframe" style={{display:'none'}}></iframe>
          </div>
        </div>
      </div>
    </Router>
  );
};

export default Routes;
